import { Box, Button, Input, Stack, Text } from "@chakra-ui/react";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import FormLabelWithInfoTooltip from "../Widgets/FormLabelWithInfoTooltip";

// Support resource URLs — what your subaccount users see in the
// in-app help menu. Separate from "Social" (which is brand-facing)
// even though both live under branding.socials in storage.
const SupportLinks = ({ brandingForm, getAgencies }) => {
  const baseUrl = getHostDomain();
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit } = brandingForm;
  const agency = useContext(AgencyContext);
  const { agencyData, buttonColorScheme, staffRole } = agency;
  const canWrite = !staffRole || staffRole === "admin";

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await fetchController(
        baseUrl + `/api/v1/agency/${agencyData.id}`,
        "PUT",
        data
      );
      getAgencies();
      toast.success("Support resources updated");
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(onSubmit)();
      }}
    >
      <Stack direction="column" spacing={4} mb={4} maxW="520px">
        <Text fontSize="sm" color="gray.500">
          These show up in the help menu of your subaccount portal.
          Use them to point users at your docs, community chat, or
          email support.
        </Text>
        <Box>
          <FormLabelWithInfoTooltip label="Docs URL" />
          <Input
            type="url"
            placeholder="https://docs.example.com"
            {...register("branding.socials.docs")}
          />
        </Box>
        <Box>
          <FormLabelWithInfoTooltip label="Discord / community URL" />
          <Input
            type="url"
            placeholder="https://discord.gg/..."
            {...register("branding.socials.discord")}
          />
        </Box>
      </Stack>
      <Button
        isLoading={isLoading}
        colorScheme={buttonColorScheme}
        type="button"
        onClick={() => handleSubmit(onSubmit)()}
        isDisabled={!agencyData || !canWrite}
      >
        Save
      </Button>
    </form>
  );
};

export default SupportLinks;
